import * as React from "react";
import { useState, useEffect } from "react";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";

export const DropDownCell = (props) => {
  const allCustomers = props?.customers || [];
  const [filteredCustomers, setFilteredCustomers] = useState(allCustomers);

  useEffect(() => {
    setFilteredCustomers(props?.customers || []);
  }, [props.customers]);

  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    }
  };

  const onFilterChange = (e) => {
    setFilteredCustomers(
      filterBy(props?.customers || [], e.filter)
    );
  };

  const { dataItem } = props;
  const dataValue =
    (props?.customers || []).find((c) => c.id === dataItem.customerId) ||
    (dataItem.customerId ? { id: dataItem.customerId, name: dataItem.customerName } : null);

  return (
    <td>
      {dataItem.inEdit ? (
        <div className="h-9 w-full" id="poCompo">
          <ComboBox
            textField="name"
            dataItemKey="id"
            filterable={true}
            suggest={true}
            onChange={handleChange}
            onFilterChange={onFilterChange}
            value={dataValue}
            data={filteredCustomers}
            className="sm:text-sm focus:ring-0 w-full focus:border-0 py-2 px-3 h-full p-0"
            placeholder="Select Customer"
          />
        </div>
      ) : dataValue ? (
        dataValue?.name
      ) : (
        ""
      )}
    </td>
  );
};
